import React from 'react';

export interface SaveBarProps {
  lastEditedDate?: string;
  lastEditedTime?: string;
  createdBy?: string;
  onSave?: () => void;
  onPublish?: () => void;
  onSendEmail?: () => void;
  showSave?: boolean;
  showSendEmail?: boolean;
  saveDisabled?: boolean;
  saveLoading?: boolean;
  publishDisabled?: boolean;
  publishLoading?: boolean;
}

export default function SaveBar({
  lastEditedDate = '1/5/2026',
  lastEditedTime = '9:30am',
  createdBy = '{created_by}',
  onSave,
  onPublish,
  onSendEmail,
  showSave = true,
  showSendEmail = false,
  saveDisabled,
  saveLoading,
  publishDisabled,
  publishLoading,
}: SaveBarProps) {
  return (
    <div
      id="save-bar"
      className="fixed bottom-0 left-[180px] right-0 z-50 bg-white pt-[2px]"
      style={{ boxShadow: '0px -12px 50px -12px rgba(0,0,0,0.25)' }}
    >
      <div>
        <div className="relative flex h-[64px] items-center px-[24px]">
          <div className="absolute left-1/2 flex -translate-x-1/2 items-center gap-[12px] whitespace-nowrap">
            <div className="size-[8px] shrink-0 rounded-full bg-[#ff6900] opacity-60" />
            <p className="font-['Inter',sans-serif] text-[14px] font-medium leading-[20px] tracking-[-0.1504px] text-[#364153]">
              {`Last edited on ${lastEditedDate} at ${lastEditedTime} by ${createdBy}`}
            </p>
          </div>

          <div className="ml-auto flex items-center gap-[12px]">
            {showSendEmail ? (
              <button
                type="button"
                className="h-[32px] rounded-[8px] bg-[#29446D] px-[13px] text-center font-['Inter',sans-serif] text-[14px] font-medium leading-[20px] tracking-[-0.1504px] text-white"
                onClick={onSendEmail}
              >
                Send Email
              </button>
            ) : null}

            {showSave ? (
              <button
                type="button"
                className="h-[32px] rounded-[8px] bg-white px-[13px] text-center font-['Inter',sans-serif] text-[14px] font-medium leading-[20px] tracking-[-0.1504px] border border-[rgba(0,0,0,0.1)] disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={() => {
                  console.log('[SaveBar] Save button clicked');
                  onSave?.();
                }}
                disabled={saveDisabled || saveLoading}
              >
                {saveLoading ? 'Saving…' : 'Save'}
              </button>
            ) : null}

            <button
              type="button"
              className="h-[32px] rounded-[8px] bg-[#6bbc58] px-[24px] text-center font-['Inter',sans-serif] text-[14px] font-bold leading-[20px] tracking-[-0.1504px] text-white disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={() => {
                console.log('[SaveBar] Publish button clicked');
                onPublish?.();
              }}
              disabled={publishDisabled || publishLoading}
            >
              {publishLoading ? 'Publishing…' : 'Publish'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
